var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"mt-3",staticStyle:{"opacity":".8"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }